import {
  SUBMIT_DELIVERY_EXCELLENCE_REQUEST,
  SUBMIT_DELIVERY_EXCELLENCE_SUCCESS,
  SUBMIT_DELIVERY_EXCELLENCE_FAILURE,
} from "../actions/deliveryExcellenceActions";

const initialState = {
  loading: false,
  successMessage: "",
  errorMessage: "",
};

const deliveryExcellenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_DELIVERY_EXCELLENCE_REQUEST:
      return { ...state, loading: true, successMessage: "", errorMessage: "" };
    case SUBMIT_DELIVERY_EXCELLENCE_SUCCESS:
      return { ...state, loading: false, successMessage: action.payload };
    case SUBMIT_DELIVERY_EXCELLENCE_FAILURE:
      return { ...state, loading: false, errorMessage: action.payload };
    default:
      return state;
  }
};

export default deliveryExcellenceReducer;